import React, {  useState,useEffect } from 'react';
import RightSideAcc from './rightAccordion';
import FltrClientName from './client-name-flt';
import UploadTabs from './uploadTabs';
import FilterCategoryList from './category-list';
import FilterProjectType from './project-type';
import FilterVendorName from './vendor-name';
import FilterBatchName from './batch-name';
import { useCreateLink } from './hooks';
import { toast } from 'react-toastify';

function TabByInvoices() {
    const [files, setFiles] = useState([]);
    const [ClientName, setClientName] = useState(null);
    const [Category, setCategory] = useState(null);
    const [ProjectType, setProjectType] = useState(null);
    const [VendorName, setVendorName] = useState(null);
    const [BatchName, setBatchName] = useState(null);
    const [refetchBatch, setRefetchBatch] = useState(false);

    const [ClientId, setClientId] = useState(null);
    const [CategoryId, setCategoryId] = useState(null);
    const [ProjectTypeId, setProjectTypeId] = useState(null);
    const [VendorNameId, setVendorNameId] = useState(null);
    const [BatchNameId, setBatchNameId] = useState(null);
    const generateLinkHook = useCreateLink()
    const [genLink, setGenLink] = useState(null);
    const [reqEmail, setreqEmail] = useState(null)

    useEffect(() => {
        // Check if any of the conditions are not met; if so, reset BatchName
        // if (!ClientName || !Category || !ProjectType) {
            setBatchName('');
            setBatchNameId('');
        // }
    }, [ClientName, Category, ProjectType]);

    async function handleGenerateLink() {
        setGenLink(null)
        setreqEmail(null)
        if (!ClientName || !Category || !ProjectType) {
            toast.error('Please select Client Name, Category, and Project Type before generating a link.');
            return;
        }
        try {
            const response = await generateLinkHook.mutateAsync({
                ClientId,
                CategoryId,
                ProjectTypeId,
                VendorNameId,
                BatchNameId
            });
            console.log(response);
            if (response?.folder_path) {
                setGenLink(response?.folder_path);
                setreqEmail(response?.receiver_email)
            } else {
                toast.error('Failed to generate link. Please try again.');
            }
        } catch (error) {
            console.error(error);
        }
    }

    return (
        <>
            <div className="pt-5 px-10 pb-10 border-b">
                <h5 className="text-sm font-black text-primary mb-5">Upload Documents</h5>
                <div className="lg:grid lg:grid-cols-3 lg:gap-6">
                    <div className="py-3 lg:py-0">
                        <FltrClientName
                            setClientName={setClientName}
                            ClientName={ClientName}
                            setClientId={setClientId}
                            ClientId={ClientId}
                        />
                    </div>
                    <div className="py-3 lg:py-0">
                        <FilterCategoryList
                            setCategory={setCategory}
                            Category={Category}
                            setCategoryId={setCategoryId}
                            CategoryId={CategoryId}
                        />
                    </div>
                    <div className="py-3 lg:py-0">
                        <FilterProjectType
                            setProjectType={setProjectType}
                            ProjectType={ProjectType}
                            setProjectTypeId={setProjectTypeId}
                            ProjectTypeId={ProjectTypeId}
                        />
                    </div>
                    <div className="py-3 lg:py-0">
                        <FilterVendorName
                            setVendorName={setVendorName}
                            VendorName={VendorName}
                            setVendorNameId={setVendorNameId}
                            VendorNameId={VendorNameId}
                            required='false'
                        />
                    </div>
                    {ClientName && Category && ProjectType && (
                        <div className="py-3 lg:py-0">
                            <FilterBatchName
                                setBatchName={setBatchName}
                                BatchName={BatchName}
                                setBatchNameId={setBatchNameId}
                                BatchNameId={BatchNameId}
                                ClientName={ClientName}
                                Category={Category}
                                ProjectType={ProjectType}
                                refetchBatch={refetchBatch}
                                disabled={!ClientName || !Category || !ProjectType}
                            />
                        </div>
                    )}
                </div>
            </div>
            
            {/* Generate Link Section */}
            <div className="px-10 py-6 border-b bg-gray-50">
                {reqEmail && <p className="text-gray-500 mb-5">
                            Notification for these files will be sent to <span className="font-medium text-gray-700">{reqEmail}</span>
                            </p>}
                <div className="flex items-center gap-4">
                    
                    <button disabled={generateLinkHook.isPending} onClick={handleGenerateLink} className={`disabled:bg-gray-300 inline-flex items-center px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg shadow-sm transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2`}>
                        <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
                        </svg>
                        Generate Link
                    </button>
                    {genLink && (
                        <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-3 space-y-2 sm:space-y-0 text-sm text-gray-700">
                            
                            <div className="flex items-center space-x-2">
                            <span className="text-gray-600">Here is the generated</span>
                            <a
                                href={genLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium transition-colors duration-200"
                            >
                                <svg
                                className="w-4 h-4 mr-1"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                                >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                                />
                                </svg>
                                link
                            </a>
                            </div>

                            
                        </div>
                        )}

                </div>
            </div>
            
            <div className="lg:flex">
                <div className="grow border-t lg:border-t-0 lg:border-r">
                    <UploadTabs
                        files={files}
                        setFiles={setFiles}
                        ClientName={ClientName}
                        Category={Category}
                        ProjectType={ProjectType}
                        VendorName={VendorName}
                        setCategory={setCategory}
                        setClientName={setClientName}
                        setProjectType={setProjectType}
                        setVendorName={setVendorName}
                        setClientId={setClientId}
                        ClientId={ClientId}
                        setCategoryId={setCategoryId}
                        CategoryId={CategoryId}
                        setProjectTypeId={setProjectTypeId}
                        ProjectTypeId={ProjectTypeId}
                        setVendorNameId={setVendorNameId}
                        VendorNameId={VendorNameId}
                        BatchName={BatchName}
                        setBatchName={setBatchName}
                        BatchNameId={BatchNameId}    
                        setBatchNameId={setBatchNameId}
                        setRefetchBatch={setRefetchBatch}
                    />
                </div>
                <div className="flex-none lg:w-[30%]">
                    <RightSideAcc files={files} />
                </div>
            </div>
        </>
    );
}

export default TabByInvoices;